import {
  MessageUnreadCount,
  PositionChanged,
  PriceAlertActivated,
  Toast,
  UserStreamMessage,
  UserStreamMessageType,
  UserStreamOrder,
  useUserStreamPortfolioLoader,
} from '@eih-netbroker/common';
import { useAtomValue } from 'jotai/index';
import { useCallback, useMemo } from 'react';
import { useCollateralSummary } from '../../../modules/portfolio/services/useCollateralSummary';
import { Config } from '../../config/config';
import { primaryInstanceAtom } from '../../state/primaryInstanceAtom';
import { useInventory } from '../inventory/useInventory';
import { useUserStreamMessage } from './useUserStreamMessage';
import { useUserStreamOrder } from './useUserStreamOrder';
import { useUserStreamPriceAlert } from './useUserStreamPriceAlert';
import { useUserStreamToast } from './useUserStreamToast';

export const useUserStreamMessageHandlerWeb = () => {
  const userStreamToast = useUserStreamToast();
  const userStreamOrder = useUserStreamOrder();
  const userStreamMessageCount = useUserStreamMessage();
  const { loadCollateralSummary } = useCollateralSummary();
  const { loadInventoryDetails, parseAndSavePortfolio } = useInventory();
  const userStreamPortfolio = useUserStreamPortfolioLoader({
    config: Config,
    isPrimaryInstance: useAtomValue(primaryInstanceAtom),
    loadCollateralSummary,
    loadInventoryDetails,
    parseAndSavePortfolio,
  });
  const userStreamPriceAlert = useUserStreamPriceAlert();

  const handleUserStreamMessage = useCallback(
    (message: UserStreamMessage) => {
      switch (message.$type) {
        case UserStreamMessageType.Toast:
          return userStreamToast(message as Toast);
        case UserStreamMessageType.Order:
          return userStreamOrder(message as UserStreamOrder);
        case UserStreamMessageType.MessageUnreadCount:
          return userStreamMessageCount(message as MessageUnreadCount);
        case UserStreamMessageType.KeepAlive:
          // do nothing
          break;
        case UserStreamMessageType.PositionChanged:
          return userStreamPortfolio(message as PositionChanged);
        case UserStreamMessageType.PriceAlertActivated:
          return userStreamPriceAlert(message as PriceAlertActivated);

        default:
          console.warn(`Invalid message from user stream: ${message.$type}`);
          return;
      }
    },
    [userStreamToast, userStreamOrder, userStreamMessageCount, userStreamPortfolio, userStreamPriceAlert],
  );

  return useMemo(() => {
    return {
      handleUserStreamMessage,
    };
  }, [handleUserStreamMessage]);
};
